import React from 'react';
import PropTypes from 'prop-types';
import faker from '@faker-js/faker';

import { VjsComponent } from 'Components/VideoPlayer';

const CUSTOM_PLAYER_EVENT = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
};

const ForwardButton = ({ player, seconds, name, ...props }) => {
  return (
    <VjsComponent
      name={name}
      player={player}
      componentType={VjsComponent.COMPONENT_TYPES.SEEK_BUTTON}
      options={{ direction: 'forward', seconds }}
      onTouchEndCapture={(e) => {
        player.trigger(CUSTOM_PLAYER_EVENT.FORWARD);
        e.stopPropagation();
      }}
      onClick={(e) => {
        player.trigger(CUSTOM_PLAYER_EVENT.FORWARD);
        e.stopPropagation();
      }}
      {...props}
    />
  );
};

ForwardButton.propTypes = {
  player: PropTypes.object,
  seconds: PropTypes.number,
  name: PropTypes.string,
};

ForwardButton.defaultProps = {
  seconds: 10,
  name: faker.random.uuid(),
};

const BackwardButton = ({ player, seconds, name, ...props }) => {
  return (
    <VjsComponent
      name={name}
      player={player}
      componentType={VjsComponent.COMPONENT_TYPES.SEEK_BUTTON}
      options={{ direction: 'back', seconds }}
      onTouchEndCapture={(e) => {
        player.trigger(CUSTOM_PLAYER_EVENT.BACKWARD);
        e.stopPropagation();
      }}
      onClick={(e) => {
        player.trigger(CUSTOM_PLAYER_EVENT.BACKWARD);
        e.stopPropagation();
      }}
      {...props}
    />
  );
};

BackwardButton.propTypes = {
  player: PropTypes.object,
  seconds: PropTypes.number,
  name: PropTypes.string,
};

BackwardButton.defaultProps = {
  seconds: 10,
  name: faker.random.uuid(),
};

export { CUSTOM_PLAYER_EVENT, ForwardButton, BackwardButton };
